// Shared multi-bank eligibility logic used by Tools > Multi-Bank Eligibility
// and the Compare Banks card on a lead. Pure client-side calc over /api/lenders.

export function loanFromEmi(monthlyEmi, annualRate, months) {
  const r = annualRate / 12 / 100;
  if (!monthlyEmi || !months) return 0;
  if (r === 0) return monthlyEmi * months;
  return (monthlyEmi * (Math.pow(1 + r, months) - 1)) / (r * Math.pow(1 + r, months));
}

// Returns active lenders annotated with eligibility for the given profile.
// requestedAmount (optional): when provided, a bank only "qualifies" if its
// eligible capacity also covers the requested amount.
export function computeBankEligibility(lenders = [], { income, obligations = 0, rate = 14, months = 60, foir = 50, requestedAmount = 0 }) {
  const active = lenders.filter((l) => l.active);
  const affordableEmi = Math.max(0, Number(income || 0) * (Number(foir) / 100) - Number(obligations || 0));
  const capacity = Math.round(loanFromEmi(affordableEmi, Number(rate), Number(months)));
  return active
    .map((l) => {
      const meetsIncome = Number(income || 0) >= (l.min_income || 0);
      const meetsAmount = !requestedAmount || capacity >= Number(requestedAmount);
      const qualifies = meetsIncome && meetsAmount;
      return { ...l, meetsIncome, meetsAmount, qualifies, eligibleAmount: meetsIncome ? capacity : 0, affordableEmi: Math.round(affordableEmi) };
    })
    .sort((a, b) => (b.qualifies - a.qualifies) || b.eligibleAmount - a.eligibleAmount);
}
